module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"EntryModal":{"button":"Pokračovat","heading":"Pozor! Stránka je pro dospělé.","text":"Pokračováním potvrzujete, že jste starší 18 let."}},"en":{"EntryModal":{"button":"Continue","heading":"Warning, adult content","text":"By continuing to this website, you confirm you are over 18 years of age."}}}')
  delete Component.options._Ctor
}
